import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { Img } from "arv-reactcomponents";
import { PAYMENTPAGE } from "npmlinks-constants";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import { PAYUForm } from "../../PaymentGateway";
import PaytmOtp from "./PaytmOtp";

@inject("PaymentStore", "WalletStore", "LoginStore", "CheckoutStore")
@observer
class Paytm extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    Analytics.trackEvent({
      action: Event.action.PAYMENT_PAYTM_SELECTED,
      category: window.pageType,
    });
    this.props.WalletStore.setSelectedWallet(PAYMENTPAGE.PAYTM);
  }


  render() {
    const { selectedWallet, success } = this.props.WalletStore;
    let { transactions = {} } = success;
    let { banking: { requestParameters = [] } = {} } = transactions;
    const addBalance =
      requestParameters && requestParameters.length;
    const { sendOTPFlag } = selectedWallet || {};
    return (
      <div className="nw-paytm-section">
        {addBalance ? (
          <PAYUForm.component
            formData={success}
            componentName="wallet"
          />
        ) : (
          ""
        )}
        {sendOTPFlag && !addBalance ? <PaytmOtp.component /> : ""}
      </div>
    );
  }
}

Paytm.wrappedComponent.propTypes = {
  WalletStore: PropTypes.shape({
    success: PropTypes.shape({ }).isRequired,
    setSelectedWallet: PropTypes.func.isRequired,
    selectedWallet: PropTypes.shape({
      balance: PropTypes.string.isRequired,
    }).isRequired,
  }),
  LoginStore: PropTypes.shape({
    mobileNumber: PropTypes.string.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    pricingOverviewData: PropTypes.shape({}).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("PaymentStore", "WalletStore", "LoginStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Paytm.wrappedComponent,
  component: Paytm,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/Paytm/index.js